var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { useEntity } from "../useEntity";
import { AdminUserService } from "../../services/identity/adminUser.service";
import { UserType, USER_MANAGEMENT_USER_TYPES, MIN_PASSWORD_LENGTH } from "../../models/identity/user.model";
import { AdminUserAccessService } from "../../services/identity/adminUserAccess.service";
import ScreenWrapper from "../ScreenWrapper";
import UserBasicInfo from "./UserBasicInfo";
import { useAccordingOrganization } from "../../utils/hooks/users/useAccordingOrganization";
import { UserAccessService } from "../../services/identity/userAccess.service";
import { useAccordingOrganizationApps } from "../../utils/hooks/app/useOrganizationApps";
import { useAccordingUserTypePermittedNoteTypes } from "../../utils/hooks/notes/useNoteTypes";
import { useQuery } from "react-query";
import { MyAccountService } from "../../services/identity/myAccount.service";
var UserDetails = function (props) {
    //region State
    var _a, _b;
    var navigate = useNavigate();
    // Get the org which user is going to be assigned to
    var _c = useParams(), orgId = _c.orgId, id = _c.id;
    // Fetch organization id based on proper admin / user access
    var fetchedUserOrgId = (_a = useAccordingOrganization(props.adminAccess)) === null || _a === void 0 ? void 0 : _a.organizationId;
    // If the orgId is provided in the URL, we use it, otherwise we use the fetched user organization id
    var userOrganizationId = orgId !== null && orgId !== void 0 ? orgId : fetchedUserOrgId;
    var organizationApps = useAccordingOrganizationApps(props.adminAccess, userOrganizationId);
    // Global per-user-type note-type defaults, used to seed a newly created user.
    var userTypePermittedNoteTypes = useAccordingUserTypePermittedNoteTypes(props.adminAccess);
    var myAccountDataQ = useQuery(['myAccount'], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (props.adminAccess)
                        return [2 /*return*/, undefined];
                    return [4 /*yield*/, MyAccountService.getMyAccount()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, {
        enabled: !props.adminAccess
    });
    var userType = (_b = myAccountDataQ.data) === null || _b === void 0 ? void 0 : _b.userType;
    var restrictEditPermission = !USER_MANAGEMENT_USER_TYPES
        .includes(userType) && !props.adminAccess;
    var userData = useEntity({
        get: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (id && id !== 'new') {
                    return [2 /*return*/, props.adminAccess
                            ? AdminUserService.getUserById(id)
                            : UserAccessService.getOneUserById(id)];
                }
                else {
                    return [2 /*return*/, {}];
                }
                return [2 /*return*/];
            });
        }); },
        update: function (user) {
            return props.adminAccess
                ? AdminUserService.updateUser(user, userOrganizationId)
                : UserAccessService.updateUser(user);
        },
        create: function (user) {
            return props.adminAccess
                ? AdminUserService.createUser(user, userOrganizationId)
                : UserAccessService.createUser(user);
        },
        canDelete: function (user) { return true; },
        delete: function (id, item) { return __awaiter(void 0, void 0, void 0, function () {
            var userAccesses, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, getUserAccesses(id)];
                    case 1:
                        userAccesses = _a.sent();
                        if (!userAccesses.length) return [3 /*break*/, 3];
                        // Delete user accesses if in any organizations before deleting the user
                        return [4 /*yield*/, deleteUserAccesses(userAccesses)];
                    case 2:
                        // Delete user accesses if in any organizations before deleting the user
                        _a.sent();
                        _a.label = 3;
                    case 3: 
                    // Delete the user
                    return [4 /*yield*/, deleteUserAccount(id, userOrganizationId)];
                    case 4:
                        // Delete the user
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        console.error('Error during user access removal:', e_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); },
        onDeleted: function () { return props.adminAccess
            ? navigate("/users/")
            : navigate("/system/team/"); },
        onSaved: function (user, wasCreateAction, prev) {
            var _a;
            (_a = props.onUserChange) === null || _a === void 0 ? void 0 : _a.call(props, user);
            if (wasCreateAction) {
                props.adminAccess
                    ? navigate("/users/".concat(user.id))
                    : navigate("/system/team/".concat(user.id));
            }
        },
        showSaveSuccess: true,
        isValid: function (user) {
            var _a, _b;
            var emailAndNameValid = !!((_a = user.email) === null || _a === void 0 ? void 0 : _a.trim()) && !!((_b = user.firstName) === null || _b === void 0 ? void 0 : _b.trim());
            var passwordValid = true;
            if (id === 'new') {
                passwordValid = !!user.passwordChange && (user.passwordChange || '').trim().length >= MIN_PASSWORD_LENGTH;
            }
            else {
                passwordValid = true;
                if (user.passwordChange) {
                    passwordValid = (user.passwordChange || '').trim().length >= MIN_PASSWORD_LENGTH;
                }
            }
            return emailAndNameValid && passwordValid;
        },
        cleanupBeforeSave: function (user) {
            var _a, _b, _c, _d, _e, _f, _g;
            var selectedUserType = (_a = user.userType) !== null && _a !== void 0 ? _a : UserType.SUPER_ADMIN;
            /*
                Quick fix for release -> Commenting this on purpose as we may need it later
            */
            // const permittedAppIdsByType = userTypePermittedApps.find(uta => uta.userType === selectedUserType)?.permittedAppIds
            //
            // // Suggesting only existing apps for org and permitted for specific user
            // const initialPermittedAppIds =
            //     organizationApps
            //         .filter(orgApp => permittedAppIdsByType?.includes(orgApp.appId as string))
            //         .map(orgApp => orgApp.id as string)
            //
            // console.log('organization apps', organizationApps)
            //
            // console.log(selectedUserType)
            // console.log(initialPermittedAppIds)
            // A user created without ever touching the user-type dropdown never ran the reset
            // handler in UserBasicInfo, so seed the role's global default here — the same thing
            // permittedAppIds does one line below. Every user type now has a default (the whole
            // catalogue for the full-access roles), and the backend applies the same one for an
            // API-created user (UserServiceV3.add), so both paths land in the same place.
            var permittedNoteTypesDefault = (_b = userTypePermittedNoteTypes
                .find(function (row) { return row.userType === selectedUserType; })) === null || _b === void 0 ? void 0 : _b.permittedNoteTypes;
            return __assign(__assign({}, user), { name: (_d = (_c = user.email) === null || _c === void 0 ? void 0 : _c.trim()) === null || _d === void 0 ? void 0 : _d.toLowerCase(), firstName: (_e = user.firstName) === null || _e === void 0 ? void 0 : _e.trim(), userType: selectedUserType, permittedAppIds: (_f = user.permittedAppIds) !== null && _f !== void 0 ? _f : organizationApps.map(function (app) { return app.id; }), permittedNoteTypes: (_g = user.permittedNoteTypes) !== null && _g !== void 0 ? _g : permittedNoteTypesDefault });
        },
        onFetched: function (user) { var _a; return (_a = props.onUserChange) === null || _a === void 0 ? void 0 : _a.call(props, user); }
    }, id);
    var user = userData.item;
    var setUser = userData.setItem;
    var getUserAccesses = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!props.adminAccess) return [3 /*break*/, 2];
                    return [4 /*yield*/, AdminUserAccessService.getAll({
                            userIds: [userId],
                            organizationId: userOrganizationId,
                            // we put here 2000 as limit, in case user belongs to many organizations
                            limit: {
                                offset: 0,
                                limit: 2000
                            }
                        })];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, UserAccessService.getAll({
                        userIds: [userId],
                        // we put here 2000 as limit, in case user belongs to many organizations
                        limit: {
                            offset: 0,
                            limit: 2000
                        }
                    })];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    return [2 /*return*/, response.content || []];
            }
        });
    }); };
    var deleteUserAccesses = function (userAccesses) { return __awaiter(void 0, void 0, void 0, function () {
        var accessIds, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    accessIds = userAccesses.map(function (access) { return access.id; });
                    if (!props.adminAccess) return [3 /*break*/, 2];
                    return [4 /*yield*/, AdminUserAccessService.delete({ id: accessIds })];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, UserAccessService.delete({ id: accessIds })];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    _a;
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteUserAccount = function (userId, orgId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!props.adminAccess) return [3 /*break*/, 2];
                    return [4 /*yield*/, AdminUserService.deleteUser({ id: [userId] }, userOrganizationId)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, UserAccessService.deleteUser({ id: [userId] })];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    _a;
                    return [2 /*return*/];
            }
        });
    }); };
    //endregion Sate
    var basicInfo = (_jsx(UserBasicInfo, { user: user, setUser: setUser, userData: userData, adminAccess: props.adminAccess, restrictEditPermission: restrictEditPermission, restrictLogInAsAnotherUser: !props.adminAccess, renderHeader: props.renderHeader }));
    return props.adminAccess ? (_jsx(ScreenWrapper, { children: basicInfo })) : (_jsx(Box, __assign({ sx: { width: '100%', pb: 8 } }, { children: basicInfo })));
};
export default UserDetails;
